import React, { useMemo, useState,useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Pagination,
  PaginationItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Card,
  CardContent,
  CardActions,
  CardMedia,
} from "@mui/material";
import BannerImage from "../../assets/images/store-banner.png";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import products from "../../mocks/product.json";
import styles from "./index.module.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";
import Nav from "../../components/Nav";
import Breadcrumb from "../../components/Breadcrumb";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DiabetesSupplyImg from "../../assets/images/Diabetes supply.jpg"
import MobilitySupplyImg from "../../assets/images/Mobility supply.jpg"
import OthersImg from "../../assets/images/Others.jpg"


const pageSize = 5;

function Products(props) {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [filterIds, setFilterIds] = useState([]);
  const [categorySelected, setCategorySelected] = useState(null);
  const flattenProducts = useMemo(() => {
    if (!categorySelected) return [];
    const categoryProduct = products.find((p) => p.id === categorySelected);
    return categoryProduct ? categoryProduct.list : [];
  }, [categorySelected]);

  useEffect(() => {
    setFilterIds(flattenProducts.map((p) => p.id));
  }, [flattenProducts]);

  const [showFilter, setShowFilter] = useState(false);

  const filteredProducts = useMemo(() => {
    if (filterIds.length) {
      return flattenProducts.filter((p) => filterIds.includes(p.id));
    }
    return flattenProducts;
  }, [filterIds]);

  const paginatedProducts = useMemo(() => {
    const acpage = page - 1;
    const offset = acpage * pageSize;
    return filteredProducts.slice(offset, offset + pageSize);
  }, [page, filteredProducts]);

  const onFilter = (id) => {
    const isAdded = filterIds.includes(id);
    let newIds = [];
    if (isAdded) {
      newIds = filterIds.filter((_id) => _id !== id);
    } else {
      newIds = [...filterIds, id];
    }
    setPage(1);
    setFilterIds(newIds);
  };

  const [expandedHeadings, setExpandedHeadings] = useState([]);
  const [selectedHeadings, setSelectedHeadings] = useState([]);

  const toggleHeading = (id) => {
    setExpandedHeadings((prev) =>
      prev.includes(id) ? prev.filter((h) => h !== id) : [...prev, id]
    );
  };

  const toggleHeadingCheckbox = (id, subIds) => {
    const isSelected = selectedHeadings.includes(id);
    if (isSelected) {
      setSelectedHeadings((prev) => prev.filter((h) => h !== id));
    } else {
      setSelectedHeadings((prev) => [...prev, id]);
    }
  };

useEffect(() => {
  if (selectedHeadings.length === 0) {
    setFilterIds(flattenProducts.map((p) => p.id));
  } else {
    const selectedSubIds = products
      .filter((p) => selectedHeadings.includes(p.id))
      .map((p) => p.list.map((cp) => cp.id))
      .flat();
    setFilterIds(selectedSubIds);
  }
}, [selectedHeadings]);

  return (
    <Stack className={styles.landingPage} component="main" direction="column">
      <Stack className={styles.mainSection}>
        <Box className={styles.heroBanner}>
          <img src={BannerImage} alt="hero-banner" />
        </Box>
        <Box className={styles.content}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <TextField
              variant="outlined"
              size="small"
              sx={{
                height: "32px",
                "& .MuiOutlinedInput-root": {
                  height: "32px",
                  backgroundColor: "white",
                  borderRadius: 0,
                },
                "& .MuiInputBase-root": {
                  paddingRight: "2px",
                },
                "& .MuiInputBase-input": {
                  paddingRight: "32px",
                },
              }}
              placeholder="Search"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Stack color="primary" sx={{}}>
                      <SearchIcon
                        sx={{
                          backgroundColor: "#0a9a73",
                          color: "white",
                          padding: "2px",
                        }}
                      />
                    </Stack>
                  </InputAdornment>
                ),
              }}
            />
            <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
              <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  background: "white",
                  height: "30px",
                  borderRadius: "4px",
                  padding: "8px",
                  boxSizing: "border-box",
                }}
              >
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{ alignItems: "center" }}
                >
                  <Typography sx={{ lineHeight: 1 }} variant="overline">
                    EN
                  </Typography>
                  <ExpandMoreIcon sx={{ stroke: 0.5 }} />
                </Stack>
                <Divider sx={{ mx: "4px" }} orientation="vertical" />
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{ alignItems: "center" }}
                >
                  <Typography sx={{ lineHeight: 1 }} variant="overline">
                    USD
                  </Typography>
                  <ExpandMoreIcon />
                </Stack>
              </Stack>
              <Button
                variant="contained"
                size="small"
                sx={{ display: { xs: "none", sm: "block" } }}
              >
                Login | Pay Bill
              </Button>
              <Tooltip title="Login | Pay Bill">
                <IconButton
                  variant="contained"
                  size="large"
                  sx={{ color: "white", display: { xs: "flex", sm: "none" } }}
                >
                  <AccountCircleIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
          <Nav />
          <Breadcrumb
            links={[{ title: "Home", url: "/" }, { title: "Medical Supplies" }]}
          />
        </Box>
      </Stack>
      <Box sx={{ background: "white" }}>
        <Box className={styles.content}>
          <Stack direction="column">
            <Stack direction="row" sx={{ alignItems: "center" }}>
              <IconButton
                onClick={() => setShowFilter(true)}
                sx={{ display: { xs: "block", md: "none" } }}
              >
                {/* <FilterAltIcon /> */}
              </IconButton>
              <Typography sx={{ my: "2rem" }} variant="h4">
                Medical Supplies
              </Typography>
            </Stack>
          </Stack>
          <Box sx={{ px: 5 }}>
            <Stack direction={{ xs: "column", lg: "row" }} spacing={{ xs: 6, lg: 2 }}>
              <Stack direction={{ xs: "column", lg: "row" }} spacing={{ xs: 6, sm:6, md:6, lg: 4, xl:5 }} flexWrap="wrap">
                <Card
                  sx={{
                    // maxWidth: { xs: "100%", sm: "354px" },
                    // width: { xs: "100%", sm: "354px" },
                    width: { xs: '100%', sm: '95%', md: '95%', lg: '31%', xl: '31%' },
                    opacity: 0.9,
                    cursor: "pointer",
                      "&:hover": {
                        boxShadow: "0px 0px 4px #20bfa9",
                        pointer: "cursor !important",
                      },
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ height: 250 }}
                    src={DiabetesSupplyImg}
                    title="Diabetes"
                  />
                  <CardContent sx={{ padding: "25px", pb: 0 }}>
                    <Typography gutterBottom variant="h5" component="div">
                      Diabetes
                    </Typography>
                    <Typography gutterBottom variant="body1" component="div">
                      Reliable medical devices for accurate blood sugar monitoring and insulin delivery. Supporting daily diabetes...
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ mb: "20px", pl: "25px" }}>
                    <Button
                      onClick={() => navigate("/medicalsupplies/diabetes")}
                      size="small"
                      variant="contained"
                    >
                      Learn More
                    </Button>
                  </CardActions>
                </Card>

                <Card
                  sx={{
                    // maxWidth: { xs: "100%", sm: "354px" },
                    // width: { xs: "100%", sm: "354px" },
                    width: { xs: '100%', sm: '95%', md: '95%', lg: '31%', xl: '31%' },
                    opacity: 0.9,
                    cursor: "pointer",
                      "&:hover": {
                        boxShadow: "0px 0px 4px #20bfa9",
                        pointer: "cursor !important",
                      },
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ height: 250 }}
                    src={MobilitySupplyImg}
                    title="Mobility"
                  />
                  <CardContent sx={{ padding: "25px", pb: 0 }}>
                    <Typography gutterBottom variant="h5" component="div">
                      Mobility
                    </Typography>
                    <Typography gutterBottom variant="body1" component="div">
                      Durable and supportive mobility aids designed for safety and independence. Includes wheelchairs, walkers... 
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ mb: "20px", pl: "25px" }}>
                    <Button
                      onClick={() => navigate("/medicalsupplies/mobility")}
                      size="small"
                      variant="contained"
                    >
                      Learn More
                    </Button>
                  </CardActions>
                </Card>

                <Card
                  sx={{
                    // maxWidth: { xs: "100%", sm: "354px" },
                    // width: { xs: "100%", sm: "354px" },
                    width: { xs: '100%', sm: '95%', md: '95%', lg: '31%', xl: '31%' },
                    opacity: 0.9,
                    cursor: "pointer",
                      "&:hover": {
                        boxShadow: "0px 0px 4px #20bfa9",
                        pointer: "cursor !important",
                      },
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ height: 250 }}
                    src={OthersImg}
                    title="Others"
                  />
                  <CardContent sx={{ padding: "25px", pb: 0 }}>
                    <Typography gutterBottom variant="h5" component="div">
                      Others
                    </Typography>
                    <Typography gutterBottom variant="body1" component="div">
                      Essential medical tools for home, clinical, and emergency use. Enhancing healthcare delivery with user-friendly...
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ mb: "20px", pl: "25px" }}>
                    <Button
                      onClick={() => navigate("/medicalsupplies/other")}
                      size="small"
                      variant="contained"
                    >
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}

Products.propTypes = {};

export default Products;
